import { REDUX_ACTIONS } from '../../shared/config/constants';

const initialState = {
  loading: false,
  deleting: false,
  data: [],
  errorMessage: '',
  loadingDelete: false,
  saved: false,
  paginatedElements: 0,
  initialData: [],
  PODSave: false,
  companyUsers: [],
  companyUsersLoading: false,
  companyUsersErrorMessage: '',
  orders: {
    loading: false,
    data: [],
    errorMessage: '',
    paginatedElements: 0,
  },
  quotes: {
    loading: false,
    data: [],
    errorMessage: '',
    paginatedElements: 0,
  },
  salesReps: {
    data: [],
    loading: false,
    errorMessage: ''
  },
  alarmsRecipientUsers: {
    loading: false,
    data: [],
    errorMessage: ''
  },
  disableAdd: false
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.USERS_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: ''
      };
    case REDUX_ACTIONS.USERS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.payload.users],
        paginatedElements: action.payload.paginatedElements,
        errorMessage: ''
      };
    case REDUX_ACTIONS.USERS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
        data: []
      };
    case REDUX_ACTIONS.USERS_LIST_ERROR_NOTIFIED:
      return {
        ...state,
        errorMessage: '',
        data: []
      };
    case REDUX_ACTIONS.USERS_POD_UPLOAD_LOADING:
      return {
        ...state,
        PODSave: true
      };
    case REDUX_ACTIONS.USERS_SET_POD: {
      const userIndex = state.data.findIndex(item => item._id === action.payload.userId);
      const orderIndex = userIndex !== -1 ? state.data[userIndex].orders.findIndex(order => order._id === action.payload.orderId) : -1;
      if (userIndex !== -1 && orderIndex !== -1) {
        const updatedUserDetails = [...state.data];
        updatedUserDetails[userIndex].orders[orderIndex].POD = action.payload.POD;
        return {
          ...state,
          PODSave: false,
          data: updatedUserDetails
        };
      }
      return state;
    }
    case REDUX_ACTIONS.USERS_RESET:
      return {
        ...initialState
      };
    case REDUX_ACTIONS.COMPANIES_USERS_LIST_LOADING:
      return {
        ...state,
        companyUsersLoading: true,
        companyUsersErrorMessage: ''
      };
    case REDUX_ACTIONS.COMPANIES_USERS_LIST_ERROR:
      return {
        ...state,
        companyUsersLoading: false,
        companyUsersErrorMessage: action.payload.message,
        companyUsers: []
      };
    case REDUX_ACTIONS.COMPANIES_USERS_LIST_SUCCESS:
      return {
        ...state,
        companyUsers: action.payload,
        companyUsersLoading: false
      };
    case REDUX_ACTIONS.USER_ORDERS_LIST_LOADING:
      return {
        ...state,
        orders: {
          ...state.orders,
          loading: true,
          errorMessage: '',
        },
      };
    case REDUX_ACTIONS.USER_ORDERS_LIST_SUCCESS:
      return {
        ...state,
        orders: {
          loading: false,
          data: action.payload.data,
          paginatedElements: action.payload.paginatedElements,
          errorMessage: '',
        },
      };
    case REDUX_ACTIONS.USER_ORDERS_LIST_ERROR:
      return {
        ...state,
        orders: {
          loading: false,
          data: [],
          errorMessage: action.payload.message,
        },
      };
    case REDUX_ACTIONS.USER_QUOTES_LIST_LOADING:
      return {
        ...state,
        quotes: {
          ...state.quotes,
          loading: true,
          errorMessage: '',
        },
      };
    case REDUX_ACTIONS.USER_QUOTES_LIST_SUCCESS:
      return {
        ...state,
        quotes: {
          loading: false,
          data: action.payload.data,
          paginatedElements: action.payload.paginatedElements,
          errorMessage: '',
        },
      };
    case REDUX_ACTIONS.USER_QUOTES_LIST_ERROR:
      return {
        ...state,
        quotes: {
          loading: false,
          data: [],
          errorMessage: action.payload.message,
        },
      };
    case REDUX_ACTIONS.SALES_REPS_LIST_LOADING:
      return {
        ...state,
        salesReps: {
          ...state.salesReps,
          loading: true,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.SALES_REPS_LIST_SUCCESS:
      return {
        ...state,
        salesReps: {
          ...state.salesReps,
          loading: false,
          data: [...action.payload.data],
          paginatedElements: action.payload.paginatedElements,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.SALES_REPS_LIST_ERROR:
      return {
        ...state,
        salesReps: {
          ...state.salesReps,
          loading: false,
          errorMessage: action.payload.message,
          data: []
        }
      };
    case REDUX_ACTIONS.ALARMS_RECIPIENTS_USERS_LIST_LOADING:
      return {
        ...state,
        alarmsRecipientUsers: {
          ...state.alarmsRecipientUsers,
          loading: true,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.ALARMS_RECIPIENTS_USERS_LIST_SUCCESS:
      return {
        ...state,
        alarmsRecipientUsers: {
          ...state.alarmsRecipientUsers,
          loading: false,
          data: [...action.payload.users],
          paginatedElements: action.payload.paginatedElements,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.ALARMS_RECIPIENTS_USERS_LIST_ERROR:
      return {
        ...state,
        alarmsRecipientUsers: {
          ...state.alarmsRecipientUsers,
          loading: false,
          errorMessage: action.payload.message,
          data: []
        }
      };
    case REDUX_ACTIONS.USERS_ADD_DISABLE: {
      return {
        ...state,
        disableAdd: action.payload
      };
    }
    default:
      return state;
  }
};

export default usersReducer;
